import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore, initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBeisgxmP7tSsN9SJdoqx3RelUY3or1mwk",
  authDomain: "inewsbook-1402f.firebaseapp.com",
  // authDomain: "ainewsapp.net", 
  projectId: "inewsbook-1402f",
  storageBucket: "inewsbook-1402f.firebasestorage.app",
  messagingSenderId: "753931936573",
  appId: "1:753931936573:web:07a7c6bc45f043389e9b54",
  measurementId: "G-29QLKXBTFW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const googleProvider = new GoogleAuthProvider();

export { auth, db, storage, googleProvider, app };